import { IReservation } from 'app/core/interfaces/reservation.interface';
import { DriversModel } from '../drivers/drivers.model';
import { StandingOrderModel } from './standingOrder.model';
import { TripLocationModel } from './triplocation.model';

export class TripModel {
    public tripreasonsignid: number;
    public tripcancelreasonid: number;
    public userprofileid: number;
    public acceptedtime: string;
    public raterider: number;
    public routephoto: string;
    public tripid: number;
    public consecutive: number;
    public dateofservice: string;
    public tripstatusid: number;
    public companyid: number;
    public brokerid: number;
    public companions: number;
    public estimatedtime: number;
    public vehicleid: number;
    public driverid: number;
    public calltypeid: number;
    public leg: string;
    public payorid: number;
    public callreceived: string;
    public addedon: string;
    public pickup: string;
    public pickuptime: string;

    public appointment: string;
    public caller: string;
    public callerphone: string;
    public payorauthorization: string;
    public runnumber: string;
    public hasreturn: boolean;
    public returntime: string;
    public totalmiles: number;
    public totalamount: number;
    public isloadedmiles: boolean;
    public riderid: number;
    public notetrip: string;
    public notepickup: string;
    public notedropoff: string;
    public TripLocationPickUp: TripLocationModel;
    public TripLocationDropOff: TripLocationModel;
    public tripcharges: any;
    public tripcredits: any;

    /**
     * standing order
     */
    public standingorderid: number;
    public fromdate: string;
    public todate: string;
    public sunday: boolean;
    public monday: boolean;
    public tuesday: boolean;
    public wednesday: boolean;
    public thursday: boolean;
    public friday: boolean;
    public saturday: boolean;
    public trips: TripModel;
    public standing: StandingOrderModel[];

    constructor() {
        this.TripLocationPickUp  = new TripLocationModel;
        this.TripLocationDropOff = new TripLocationModel;
        this.standing            = [];
    }
}
export class TripModelR {
    public tripconfirmed: boolean;
    public tripreasontransportid: number;
    public tripreasonsignid: number;
    public tripcancelreasonid: number;
    public userprofileid: number;
    public acceptedtime: string;
    public raterider: number;
    public routephoto: string;
    public tripid: number;
    public consecutive: number;
    public dateofservice: string;
    public dateofserviceformatted: string;
    public tripstatusid: number;
    public companyid: number;
    public brokerid: number;
    public companions: number;
    public estimatedtime: number;
    public vehicleid: number;
    public driverid: number;
    public calltypeid: number;
    public leg: string;
    public payorid: number;
    public callreceived: string;
    public addedon: string;
    public pickup: string;
    public pickuptime: string;
    public signaturephoto: string;
    public activationtime: string;
    public reservationid: number;
    public reservation: IReservation;
    public iswillcall: boolean;
    public isreturntrip: boolean;
    public isactivationnow: boolean;
    public appointment: string;
    public noshowtime: string;
    public actualdropoff: string;
    public actualpickup: string;
    public waitingtime: number;
    public waitingtimeformatted: string;
    public caller: string;
    public callerphone: string;
    public payorauthorization: string;
    public rescuenetnumber: number;
    public hasreturn: boolean;
    public returntime: string;
    public totalmiles: number;
    public totalamount: number;
    public isloadedmiles: boolean;
    public loadedmiles: number;
    public manualmiles: number;
    public rider: any;
    public riderid: number;
    public notetrip: string;
    public notepickup: string;
    public notedropoff: string;
    public triplocationpickup: TripLocationModel;
    public triplocationdropoff: TripLocationModel;
    public tripcharges: any;
    public tripcredits: any;
    public modifiedon: any;
    public driver: DriversModel;
    public vehicle: any;
    public facilityid: any;
    public facilitydescription: any;
    public providerstatusid: number;
    public isnegotiatedrate: boolean;
    public totalamountlyft: number;
    public provideramount: number;
    public faxrequestid: number;
    public paymentstatusid: number;
    public medicaltrip?: any;
    public googleordrguid?: string;
    public tripreasontransport: any;

    // TODO  wclift
    public wclift: boolean;
    public animalservice: boolean;

  /**
     * formatted fields
     */

    public noshowtimeformatted: string;
    public actualdropoffformatted: string;
    public actualpickupformatted: string;
    public activationtimeformatted: string;

    /**
     * standing order
     */
    public standingorderid: number;
    public fromdate: string;
    public todate: string;
    public sunday: boolean;
    public monday: boolean;
    public tuesday: boolean;
    public wednesday: boolean;
    public thursday: boolean;
    public friday: boolean;
    public saturday: boolean;
    public trips: TripModel;
    public standing: StandingOrderModel[];
    public escalation: boolean;
    public pumanualcoordinates = false;
    public domanualcoordinates = false;
    public ismanualpuaddress = false;
    public ismanualdoaddress = false;

    public scheduleddropofftime: string;


    public company?: any;
    public broker?: any;
    public tripstatus?: any;
    public provstatus?: any;
    public serviceproviderid?: any;
    public serviceprovidername?: string;
    public billingstatusid: number;
    public depotid: number;
    public depot?: { description?: string };
    /**** para reason delay ****/
    public triplatereasonid: number;
    public pickupdate: string | null;
    public pickupformatted: string;
    public authorizationstatusdesc: string;
    public authorizationstatusid: number;
    public trippaymentsdateformatted: string;
    public encounterstatus: any;

    constructor() {
        this.triplocationpickup  = new TripLocationModel;
        this.triplocationdropoff = new TripLocationModel;
        this.driver = new DriversModel;
        this.standing            = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip.model.ts